(function() {
  async function updateShippingBar() {
    try {
      const sectionResponse = await fetch('/cart?section_id=header-offers-bar');
      const sectionHtml = await sectionResponse.text();
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(sectionHtml, 'text/html');
      const newWrapper = newDoc.querySelector('.free-shipping-bar-wrapper');
      if (newWrapper) {
        document.querySelector('.free-shipping-bar-wrapper').outerHTML = newWrapper.outerHTML;
        initializeShippingBar();  // Re-attach listeners and re-apply state after update
      }
    } catch (error) {
      console.error('Error updating shipping bar:', error);
    }
  }

  function initializeShippingBar() {
    const container = document.querySelector('.shipping-bar-container');
    if (!container) return;

    const openBar = container.querySelector('.float-shipping-bar');
    const closeButton = openBar.querySelector('.float-close-bt');

    // Toggle functions
    function showOpen() {
      openBar.classList.remove('hidden');
      sessionStorage.setItem('barState', 'open');
    }

    function showMinimized() {
      openBar.classList.add('hidden');
      sessionStorage.setItem('barState', 'minimized');
    }

    // Event listeners
    closeButton.addEventListener('click', showMinimized);

    // On load: Determine state
    let barState = sessionStorage.getItem('barState');
    if (!barState) {
      if (!sessionStorage.getItem('sessionStarted')) {
        sessionStorage.setItem('sessionStarted', 'true');
        barState = 'open';
      } else {
        barState = 'minimized';
      }
      sessionStorage.setItem('barState', barState);
    }

    if (barState === 'open') {
      showOpen();
    } else {
      showMinimized();
    }
  }

  // PerformanceObserver to detect cart changes
  function observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          updateShippingBar();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }

  // Call on page load
  document.addEventListener('DOMContentLoaded', () => {
    initializeShippingBar();
    observeCartChanges();
  });
})();